import { RouteConfig } from 'vue-router';

import store from '@/store';
import { historyFilters } from '@/utils/history';

export const historyRoute: RouteConfig = {
  path: 'history',
  component: () => import(/* webpackChunkName: "History" */ '@/views/main/History.vue'),
  name: 'history',
  beforeEnter(to, _from, next) {
    store.dispatch('benefitsUsage/list', historyFilters(to)).then(next);
  }
};
